// Was beim Kopieren in die Zwischenablage wirklich hinausgeht.
//
// ORIGINALTEXT MARVIN (10.09.2026)
//   „dann brauche ich überall eine onclick-zwischenablage für sm, kls-id mit
//    kurzer info, dass es in die zwischenablage kopiert ist."
//
// SEIN „ÜBERALL" IST DER GANZE PUNKT. Die Zwischenablage stand vor dieser
// Version an 3 Stellen, in 3 Fassungen: einmal ohne Rückmeldung, einmal mit
// einer eigenen, einmal mit einem Zeitgeber daneben. **Eine Regel, die an 3
// Stellen steht, ist 3 Mal zu prüfen und wird einmal geprüft** - und die
// vierte Stelle bekommt dann wieder eine eigene.
//
// DIESE DATEI TRÄGT KEIN JSX. Was hier steht, lässt sich LADEN und messen;
// eine Textsuche im Bildschirmbaustein misst, dass etwas dasteht, nicht, dass
// es stimmt. Gemessen wird sie in Prüfstand 022.

/**
 * Der Wert, wie er in die Zwischenablage geht.
 *
 * NICHT SO, WIE ER AUF DEM BILDSCHIRM STEHT. Die SM-Nummer steht in der Akte
 * mit ihren führenden Nullen; wer sie in ein fremdes Feld einfügt, will
 * genau die - deshalb wird hier nichts abgeschnitten. Was hier passiert, ist
 * nur das Nötigste: Leerzeichen an den Rändern weg, denn ein Wert mit einem
 * Leerzeichen davor wird von manchem Portal abgewiesen, und man sieht es
 * nicht.
 */
export function zumKopieren(wert: unknown): string {
  return String(wert ?? '').trim();
}

/**
 * Lohnt sich der Knopf überhaupt?
 *
 * EIN KOPIERKNOPF AN EINEM LEEREN FELD IST EIN VERSPRECHEN, DAS NICHT GILT.
 * Wer ihn drückt und danach ein leeres Feld einfügt, sucht den Fehler beim
 * Einfügen und nicht bei uns.
 */
export function kopierbar(wert: unknown): boolean {
  return zumKopieren(wert).length > 0;
}

/**
 * Was nach dem Klick dasteht.
 *
 * Marvins Wort: „mit kurzer Info, dass es in die Zwischenablage kopiert ist."
 * KURZ HEISST KURZ - der Satz steht neben einem Wert in einer Tabellenzeile
 * und darf sie nicht umbrechen.
 */
export function kopiertText(was: string): string {
  return `${was} kopiert`;
}

/**
 * Wie lange die Rückmeldung stehen bleibt, in Millisekunden.
 *
 * LANG GENUG ZUM LESEN, KURZ GENUG ZUM WEITERARBEITEN. Bei 2000 war sie beim
 * zweiten Klick auf eine andere Zelle noch da und schien zur falschen zu
 * gehören.
 */
export const KOPIERT_MS = 1400;
